import { faStar } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"
import { Link } from "react-router-dom"

export default ({ guide = {} }) => {
    return (
        <div className="card rounded bg-light p-2 m-2 d-flex flex-row">
            <div className="" style={{ width: "120px", height: "120px" }}>
                <img src={ guide?.file?.Url } className="w-100 h-100 rounded" />
            </div>
            <div className="ms-2">
                <Link to={`/guide-details/${ guide.id }`} className="custom-text-color bold mb-1">{ guide.name }</Link>
                <p className="fs-9 mb-1">{ guide.cityId?.name }</p>
                <p className="text-saffron bold mb-1">₹{ guide.pricePerHour }/ hours</p>
                <div className="d-flex align-items-center">
                    {
                        Array(5).fill(0).map((_, i) =>
                            <Icon icon={faStar} className={`${ i+1 <= guide.rating ? "text-warning" : "text-secondary"} me-1 fs-9`} />
                        )
                    }
                    
                    <p className="mb-0 fs-9 text-muted bold">{ guide.rating }/5</p>
                </div>
            </div>
        </div>
    )
}